import { render, staticRenderFns } from "./Wp_home_grid_model.vue?vue&type=template&id=a78ad4c2&scoped=true&"
import script from "./Wp_home_grid_model.vue?vue&type=script&lang=js&"
export * from "./Wp_home_grid_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78ad4c2",
  null
  
)

export default component.exports